import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["onDelete", "disableIcon"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//@ts-nocheck
import { Chip, Icon, RaiseColors, withStyles } from "components/mui";
import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var styles = function styles(theme) {
  return {
    root: {
      borderRadius: 3,
      backgroundColor: RaiseColors.destructive300,
      color: RaiseColors.black,
      margin: 4
    },
    deleteIcon: {
      fontSize: 12,
      marginLeft: -4,
      "&:hover": {
        color: RaiseColors.black
      }
    }
  };
};
export default withStyles(styles)(function (_ref) {
  var onDelete = _ref.onDelete,
    disableIcon = _ref.disableIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  if (disableIcon) {
    return /*#__PURE__*/_jsx(Chip, _objectSpread({}, props));
  }
  return /*#__PURE__*/_jsx(Chip, _objectSpread(_objectSpread({}, props), {}, {
    onDelete: onDelete,
    deleteIcon: /*#__PURE__*/_jsx(Icon, {
      className: "fal fa-times",
      color: "primary"
    })
  }));
});